<div class="flex flex-col mb-4 gap-1">
  <label class="text-body-sm-500 text-surface-700 m-0">Category</label>
  <span class="text-body-xs text-surface-600">{{ category()?.description ?? 'No category selected' }}</span>
</div>

<div class="flex items-center gap-2 mb-2">
  <h3 class="text-body-sm-600 text-surface-700 m-0">Authorities</h3>
  @if (addendumProductTaxes().length < 3) {
    <i
      class="pi pi-plus-circle"
      pTooltip="Add tax authority"
      tooltipPosition="top"
      (click)="addAuthority.set(true)"
    ></i>
  }
</div>

@if (addAuthority()) {
  <div class="flex flex-col gap-2 mb-3">
    <div class="border border-outline-brown flex flex-col gap-2 p-3 rounded-lg bg-surface-50">
      <div class="flex flex-col gap-2">
        <div class="flex items-center flex-wrap gap-2">
          <label for="selectedTaxAuthorityId"> Tax Authority <span class="text-red-500">*</span> </label>
          <span class="text-body-sm text-surface-600 flex items-center gap-2 ml-auto">
            Tax Rate:
            <span class="text-body-sm-600 text-surface-700">{{ tempTaxRate()?.rate ?? 0.0 }}%</span>
          </span>
        </div>
        <p-select
          inputId="selectedTaxAuthorityId"
          [options]="taxAuthorities()"
          optionLabel="name"
          optionValue="id"
          placeholder="Select Tax Authority"
          [filter]="true"
          [showClear]="true"
          appendTo="body"
          styleClass="w-full"
          [ngModel]="selectedAuthority()"
          (ngModelChange)="onAuthorityChange($event)"
        >
          <ng-template let-authority pTemplate="item">
            <span class="block truncate">{{ authority.name }}</span>
          </ng-template>
          <ng-template let-authority pTemplate="selectedItem">
            <span class="block truncate">{{ authority.name }}</span>
          </ng-template>
        </p-select>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-body-sm text-surface-600 flex items-center gap-1.5">
          Tax Amount:
          <span class="text-body-sm-600 text-primary">${{ tempTaxRate()?.taxAmount ?? 0.0 }}</span>
        </span>
      </div>
    </div>
  </div>
}

@for (authority of addendumProductTaxes(); track authority.id; let last = $last) {
  <div [class]="'flex flex-col' + (last ? '' : ' mb-4')">
    <div class="flex items-center gap-1 min-w-0">
      <div class="flex-1 min-w-0">
        <p-select
          [options]="taxAuthorities()"
          optionLabel="name"
          optionValue="id"
          placeholder="Select Tax Authority"
          [filter]="true"
          appendTo="body"
          styleClass="w-full"
          [ngModel]="authority.taxAuthorityId"
          [disabled]="true"
        >
          <ng-template let-item pTemplate="item">
            <span class="block truncate">{{ item.name }}</span>
          </ng-template>
          <ng-template let-item pTemplate="selectedItem">
            <span class="block truncate">{{ item.name }}</span>
          </ng-template>
        </p-select>
      </div>
      @if (!buyerAndBuilderApproved()) {
        <p-button
          icon="pi pi-trash"
          [text]="true"
          severity="danger"
          styleClass="w-6 h-6"
          (onClick)="deleteTaxAuthority(authority.id)"
        />
      }
    </div>
    <div class="flex items-center justify-between flex-wrap gap-x-4 gap-y-1 text-body-xs text-surface-700 mt-1.5">
      <span>
        Tax Amount: <span class="text-body-sm-600 text-emerald-700">${{ authority.taxAmount }}</span>
      </span>
      <span>
        Tax Rate: <span class="text-body-sm-600 text-surface-700">{{ authority.taxRate }}%</span>
      </span>
    </div>
  </div>
}

<!--
  @if (addAuthority()) {
    <div class="flex justify-end gap-2 mt-2">
      <p-button label="Cancel" severity="secondary" [outlined]="true" (onClick)="addAuthority.set(false)" />
      <p-button label="Save" icon="pi pi-check" (onClick)="addNewTaxAuthority()" [disabled]="!selectedAuthority()" />
    </div>
  }
-->
